import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MenuGroupContext } from "./MenuGroup";

export function MenuItem({ link, label, menuBar = true, icon, routeMatch }) {
  const location = useLocation();
  const [active, setActive] = useState(
    location.pathname.match(routeMatch ?? link)
  );
  const menuGroupContext = useContext(MenuGroupContext);

  useEffect(() => {
    setActive(location.pathname.match(routeMatch ?? link) !== null);
  }, [location]);

  useEffect(() => {
    if (active) {
      menuGroupContext.setActive(true);
    }
  }, [active]);

  return (
    <li
      onClick={(e) => e.stopPropagation()}
      className={`menu-item${active ? " active" : ""}`}
    >
      <Link to={link}>
        {menuBar && <div className="menu-bar"></div>}
        {icon && <i className="material-icons">{icon}</i>}
        {label}
      </Link>
    </li>
  );
}
